module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "list"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "fronthead"
  }, [_vm._v("I"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("LLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "html/docimages/image1.jpg",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }, [_c('span', {
    attrs: {
      "href": "#/html/043_p1#plates1",
      "id": "plate1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jessie’s mother’s birth certificate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/044_p2#plates2",
      "id": "plate2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four generations of the Power family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/045_p3#plates3",
      "id": "plate3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Granny Riley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/046_p4#plates4",
      "id": "plate4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Granny Power")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/047_p5#plates5",
      "id": "plate5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Granny Riley and Auntie Maggie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/048_p6#plates6",
      "id": "plate6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jessie’s father aged 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/049_p7#plates7",
      "id": "plate7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A gathering of relatives at ‘The Berries’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/050_p8#plates8",
      "id": "plate8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jessie’s mother and father in 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/051_p9#plates9",
      "id": "plate9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jessie’s mother and Uncle Charlie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/052_p10#plates10",
      "id": "plate10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jessie’s father")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/053_p11#plates11",
      "id": "plate11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jessie’s mother with her older sisters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/054_p12#plates12",
      "id": "plate12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The bus and the ‘wee Fordy van’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/055_p13#plates13",
      "id": "plate13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jessie’s mother and father with three of her older sisters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/056_p14#plates14",
      "id": "plate14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jessie, eight months old")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/057_p15#plates15",
      "id": "plate15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jessie’s mother and Uncle Wullie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/058_p16#plates16",
      "id": "plate16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mona, Chrissy, Shirley and Janey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/059_p17#plates17",
      "id": "plate17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jess in her school uniform")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/060_p18#plates18",
      "id": "plate18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jess with her mother, Jeannie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/061_p19#plates19",
      "id": "plate19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jess with her father, Charlie")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c2c4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/005_list.vue
// module id = 72
// module chunks = 0